import { DexieDatabaseProvider } from '@livefree/reactive';
import '@/core/reactive/services/BestBuyService';
import '@/core/reactive/services/LoginService';
import '@/core/reactive/services/RecoveryService';
import '@/core/reactive/services/LogoutService';
import '@/core/reactive/services/MyService';
import '@/core/reactive/services/PasswordService';

export const ReactiveConfig = {
  db: {
    name: 'livefree.identity.db',
    provider: new DexieDatabaseProvider(),
    init: db => {
      db.version(4).stores({
        users: '&id',
        applications: '&id',
        twofactor: '&id',
      });
    },
  },
};
